<pp-new-dashlet-modal-value-breakdown-fields
  [ppAssetId]="assetId"
  [ppNewDashlet]="false"
  (ppAddDashlet)="editDashlet($event)"
  [ppInitialRange]="initialDashletData"
  [ppInitialName]="initialDashletName"
  (ppDeleteDashlet)="deleteDashlet()"
></pp-new-dashlet-modal-value-breakdown-fields>
